import { useState } from 'react';
import { AlertTriangle, Loader2 } from 'lucide-react';
import { api } from '../services/api';

type Props = { reminder: 'none' | 'due_soon' | 'overdue'; daysUntilDue?: number | null };
export function PaymentReminderCard({ reminder, daysUntilDue }: Props) {
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem('banker-payment-reminder-dismissed') === '1');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  if (reminder === 'none' || (reminder === 'due_soon' && dismissed)) return null;
  const overdue = reminder === 'overdue';
  const payNow = async () => {
    setLoading(true);
    setError(null);
    try {
      const { url } = await api.payNowBanker();
      window.location.assign(url);
    } catch {
      setError('We could not open payment. Please try again.');
    } finally {
      setLoading(false);
    }
  };
  return <section className={`mx-4 mt-4 rounded-xl border p-4 sm:mx-6 ${overdue ? 'border-red-400/50 bg-red-950/40' : 'border-amber-300/40 bg-amber-950/30'}`} role={overdue ? 'alert' : 'status'} aria-live="polite">
    <div className="flex items-start gap-3"><AlertTriangle className="mt-0.5 h-5 w-5 shrink-0 text-amber-300" aria-hidden="true" /><div className="min-w-0 flex-1">
      <p className="font-semibold text-white">{overdue ? 'Payment overdue - Investment Banking is disabled' : `Payment due in ${daysUntilDue ?? 0} days`}</p>
      <p className="mt-1 text-sm text-slate-200">USD 40 monthly add-on payment</p>
      {error && <p className="mt-2 text-sm font-medium text-red-200" role="alert">{error}</p>}
      <div className="mt-3 flex flex-wrap gap-2"><button type="button" onClick={() => void payNow()} disabled={loading} className="min-h-10 rounded-lg bg-teal-400 px-4 py-2 font-semibold text-slate-950 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal-200 disabled:opacity-60">{loading ? <Loader2 className="h-4 w-4 animate-spin" aria-label="Opening payment" /> : 'Pay now'}</button>
      {!overdue && <button type="button" onClick={() => { sessionStorage.setItem('banker-payment-reminder-dismissed', '1'); setDismissed(true); }} className="min-h-10 rounded-lg px-3 py-2 text-sm text-slate-200 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-slate-200">Dismiss</button>}</div>
    </div></div>
  </section>;
}
